const MUST_CHANGE_PIN_KEY = 'mustChangePin';

/**
 * Store the mustChangePin flag in sessionStorage.
 * Called from loginWithPIN (fresh login) and currentUserID (JWT re-auth / new tab).
 */
export function captureMustChangePin(mustChangePin: boolean): void {
  if (mustChangePin) {
    sessionStorage.setItem(MUST_CHANGE_PIN_KEY, 'true');
  } else {
    sessionStorage.removeItem(MUST_CHANGE_PIN_KEY);
  }
}

export function getMustChangePin(): boolean {
  return sessionStorage.getItem(MUST_CHANGE_PIN_KEY) === 'true';
}

export function clearMustChangePin(): void {
  sessionStorage.removeItem(MUST_CHANGE_PIN_KEY);
}
